import typeIs from './getTypeOf';
import { SYMBOL, OBJECT } from 'reshow-constant';

var _typeof = function _typeof(o) {
  return SYMBOL === typeIs(o) ? SYMBOL : typeIs(o, OBJECT);
};

export default _typeof;